import { Button } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import AtencionSeccionCuerpo from "./AtencionSeccionCuerpo";
import { conteoRegistros } from "../../../utils/auditoriaSecciones";
import { IconoLapiz, IconoCheck } from "./AuditIconos";

// AUDITORIA-CLINICA-REDISENO -- un solo componente para los estados de una
// sección CON registro:
//   Estado 1 "Con registro"  -> cabecera + valor + botón Corregir.
//   Estado 2 "Corrigiendo"   -> la MISMA tarjeta se transforma en sitio
//                               (borde primario + chip): ni modal ni overlay,
//                               la ficha del paciente nunca se oculta.
//   Estado 3 "Corregida"     -> badge verde + "Ver cambio", con el valor nuevo.
// El Estado 4 "Sin registro" NO es una tarjeta (es una fila del bloque
// agrupado, ver AtencionSinRegistroBloque.js).
//
// La cabecera NO muestra "Registrado dd/mm/aaaa hh:mm" como la maqueta: ese
// dato no existe -- ninguna de las 7 tablas clínicas expone un timestamp de
// registro en el detalle (FASE 0 §6). En su lugar se muestra el nº de
// registros, que sí es real.
const fmtCorto = (valor) => (valor ? format(new Date(valor), "dd/MM/yyyy HH:mm", { locale: es }) : "—");

function AtencionSeccionCard({ seccion, secciones, correccion, onCorregir, onVerCambio, editando, pie, children }) {
    const total = conteoRegistros(seccion.id, secciones);
    const corregida = !!correccion;

    return (
        <section
            className={`ac-seccion${editando ? " is-editando" : ""}`}
            id={`ac-seccion-${seccion.id}`}
            data-testid={`ac-seccion-${seccion.id}`}
            aria-labelledby={`ac-seccion-titulo-${seccion.id}`}
        >
            <header className="ac-seccion__cabecera">
                <h2 className="ac-seccion__nombre" id={`ac-seccion-titulo-${seccion.id}`}>
                    {seccion.label}
                </h2>
                {editando && (
                    <span className="ac-chip-corrigiendo" data-testid={`ac-chip-corrigiendo-${seccion.id}`}>
                        Corrigiendo
                    </span>
                )}
                {!editando && corregida && (
                    <span className="ac-badge-corregido" data-testid={`ac-corregido-${seccion.id}`}>
                        <IconoCheck size={12} />
                        Corregido por {correccion.actor?.full_name || "un auditor"} · {fmtCorto(correccion.created_at)}
                    </span>
                )}
                {!editando && (
                    <div className="ac-seccion__meta">
                        <span>
                            {total} registro{total === 1 ? "" : "s"}
                        </span>
                        {corregida && onVerCambio && (
                            <Button size="small" type="link" onClick={() => onVerCambio(seccion.id)} data-testid={`ac-vercambio-${seccion.id}`}>
                                Ver cambio
                            </Button>
                        )}
                        {onCorregir && (
                            <Button size="small" onClick={() => onCorregir(seccion.id)} icon={<IconoLapiz />} data-testid={`ac-corregir-${seccion.id}`}>
                                Corregir
                            </Button>
                        )}
                    </div>
                )}
            </header>
            <div className="ac-seccion__cuerpo">
                {children || <AtencionSeccionCuerpo idSeccion={seccion.id} secciones={secciones} />}
            </div>
            {pie}
        </section>
    );
}

export default AtencionSeccionCard;
